"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OneMediaCenterBottomTextLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OneMediaCenterBottomTextLayout = ({
  banner,
  debug,
  modulePosition,
  className
}) => {
  const {
    modules,
    layout,
    id
  } = banner;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!modules || modules.length < 1) {
    return (0, _utils.getModulesLengthError)({
      debug,
      layout,
      modulePosition
    });
  }
  const {
    title,
    titleStorybookColor
  } = modules[0]?.content ?? {};
  const link = modules[0]?.link;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.OneMediaCenterBottomText),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.ImageBox, {
      id: id,
      module: modules[0],
      imageParams: _constants.IMAGE_PARAMS.params,
      sizes: _constants.IMAGE_PARAMS.sizes,
      height: _constants.IMAGE_DESKTOP_HEIGHT,
      width: _constants.IMAGE_DESKTOP_WIDTH
    }), title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.Title, {
        title: title,
        maxLines: 4,
        titleVariant: "h5",
        color: titleStorybookColor
      })
    }) : null, link ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.Button, {
      link: link
    }) : null]
  });
};
exports.OneMediaCenterBottomTextLayout = OneMediaCenterBottomTextLayout;
